import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '@/views/AITools/store/index'
// utils
import { copyText } from '@/utils/utils'
import { toast } from '@/utils/util'

@Component({
  props: {
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 生成状态 ( Pending: 等待生成状态; Generating: 正在生成状态; Finish: 生成完成; )
    status: {
      type: String,
      default: 'Pending'
    },
    // 生成结果
    result: {
      type: String,
      default: ''
    }
  }
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class AIToolSubmit extends Vue {

  /** 提交 */
  handleSubmit() {
    if (this.$props.status !== 'Pending') return
    this.$emit('submit')
  }

  /** 重新提交 */
  handleRetry() {
    this.$emit('retry')
  }

  /** 复制 */
  handleCopy() {
    copyText(this.$props.result)
      .then(() => {
        toast('复制成功！')
      })
      .catch(() => {
        toast('复制失败，请稍后重试')
      })
  }

}
